module.exports = __webpack_public_path__ + "static/media/wbtc.27d11ca5.png";